module.exports = __webpack_public_path__ + "static/img/LOGO_Family.d5efdf76.png";